/* EG Collections — Compare Config (meta only) */

window.EG_COLLECTION_COMPARE_CONFIG = {
  defaults: {
    maxItems: 4
  },

  default: {
    title: "Compare Products"
  },

  collections: {
     "test-collection": {
      title: "Compare Mousepads",
      maxItems: 4,
      overrides: {
        "game-type": {
          hide: true
        }
      },
      directionRules: {
        thickness: "lower",
        length: "higher",
        width: "higher",
        area: "higher"
      },
      centerHighlights: {
      maxItems: 4,
      preferredKeys: [
        "glide",
        "surface_type",
        "surface_texture",
        "firmness",
        "thickness",
        "area"
        ]
      }
    },
 
    "gaming-mousepads": {
      title: "Compare Mousepads",
      maxItems: 4,
      overrides: {
        "game-type": {
          hide: true
        }
      },
      directionRules: {
        thickness: "lower",
        length: "higher",
        width: "higher",
        area: "higher"
      },
      centerHighlights: {
      maxItems: 4,
      preferredKeys: [
        "glide",
        "surface_type",
        "surface_texture",
        "firmness",
        "thickness",
        "area"
        ]
      }
    },

    "gaming-mice-used-by-pros": {
      title: "Compare Mice",
      maxItems: 4,
      overrides: {
        size: {
          tags: ["P-Size__"]
        }
      },
      directionRules: {
        weight: "lower",
        "polling-rate": "higher"
      },
      centerHighlights: {
      maxItems: 4,
      preferredKeys: [
        "shape",
        "grip-style",
        "wired-wireless",
        "weight",
        "polling-rate",
        "cpi-dpi"
        ]
      }
    },

    "mice-skates": {
      title: "Compare Mouse Skates",
      maxItems: 4,
      directionRules: {
        thickness: "lower"
      }
    },

    "grip-tape": {
      title: "Compare Grip Tape",
      maxItems: 4,
      directionRules: {
        thickness: "lower"
      }
    },

    "arm-sleeves": {
      title: "Compare Arm Sleeves",
      maxItems: 4,
    }
  }
};